import {useUnifyAdminStore} from '../../AdminStore';
import { CampaignLinkTextInputWithHelperText } from '../Blocks/CampaignLinkTextInputWithHelperText';
import get from 'lodash/get';
import { t } from 'i18next';

export const CampaignLinkTextEnCAField = (): JSX.Element => {
    /**
     * Data Store
     */
    const campaignItems = useUnifyAdminStore((state) => state.campaignItems);
    const updateCreateCampaignData = useUnifyAdminStore((state) => state.updateCreateCampaignData);
    const permissions = useUnifyAdminStore(state => state.permissions); 
    const archiveSwitch = useUnifyAdminStore((state) => state.campaignArchiveSwitch);

    const linkText = get(campaignItems, 'linkText');

    const handleUpdateLinkTextField = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        return updateCreateCampaignData({
            fieldName: "linkText",
            value: {enCA: event.target.value, enUS: linkText?.enUS, frCA: linkText?.frCA},
        });
    };

    return (
        <>
            <CampaignLinkTextInputWithHelperText
                dataTestId="campaign-link-text-enca-input"
                id="campaign-link-text-enca-abbr-input"
                inputDivider="left"
                label={t('campaigns.learnMoreLabel')}
                name="linkText"
                onChange={handleUpdateLinkTextField}
                placeholder={t('campaigns.learnMoreEnCAPlaceholder')}
                value={campaignItems.linkText?.enCA}
                isDisabled={archiveSwitch || (campaignItems.id
                    && (!permissions?.hasCampaignUpdatePermissions && !permissions?.hasCampaignSuperAdminPermissions))}
            />
        </>
    );
};
